module.exports = __webpack_public_path__ + "img/Logo-23.a3171693.svg";